import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";

import {
  useAdminPanelToggle,
  useAdminPanelToggleContextReady,
} from "../../utils/feature-toggle-utils";

export const CAMPAIGN_OFF_REDIRECT = "/dashboard/accounts";

/**
 * SKE-4733. The Update Instagram publishing page opens only while the
 * reconnect campaign is on for this workspace.
 *
 * The page runs a pass that writes Meta permissions onto every Instagram
 * account, and it was reachable by direct link whatever the campaign was doing.
 * The server refuses the pass too; this keeps a customer from reaching a page
 * whose one action would be refused. Nothing renders until the toggles have
 * arrived, so an enabled workspace is not bounced on a cold load.
 */
export function InstagramCampaignRouteGuard({
  children,
  fallback = null,
}: {
  children: ReactNode;
  fallback?: ReactNode;
}) {
  const ready = useAdminPanelToggleContextReady();
  const campaignOn = useAdminPanelToggle("instagramReconnectCampaign");

  if (!ready) return <>{fallback}</>;
  if (!campaignOn) return <Navigate to={CAMPAIGN_OFF_REDIRECT} replace />;
  return <>{children}</>;
}
